export enum QuestionType {
    // The order of the traits tell us what side the question is on
    IE = 'IE', // Left question is Introverted, Right question is Extroverted
    EI = 'EI', // Left question is Extroverted, Right question is Introverted
    SN = 'SN', // Left question is Sensing, Right question is Intuition
    NS = 'NS', // Left question is Intuition, Right question is Sensing
    FT = 'FT', // Left question is Thinking, Right question is Feeling
    TF = 'TF', // Left question is Feeling, Right question is Thinking
    JP = 'JP', // Left question is Judging, Right question is Perceiving
    PJ = 'PJ', // Left question is Perceiving, Right question is Judging
    I = 'I',
    E = 'E',
    S = 'S',
    N = 'N',
    T = 'T',
    F = 'F',
    J = 'J',
    P = 'P',
    // Big Five - Neuroticism
    bT = 'bT',
    bA = 'bA',
    RANK = 'RANK',
}

export interface QnA_Block {
    /** A ref to the question ID, this isn't really important until we start have test variations */
    qid: string | number;
    qType: QuestionType;
    answer?: -2 | -1 | 0 | 1 | 2 | string;
    /** record of answer changes Record<timestamp, answer value> */
    answerLog?: Record<number, number | string>;
}

export interface SimpleQuestionBlock extends QnA_Block {
    /** The text of the question */
    qText: string;
    /** A image URL to use for the question */
    qUrl?: string;
    // narrowing the types of the answer
    answer?: -2 | -1 | 0 | 1 | 2;
    answerLog?: Record<number, number>;
}

export interface TwoSideQuestionBlock extends QnA_Block {
    left: string;
    right: string;
    lUrl?: string;
    rUrl?: string;
    // narrowing the types of the answer
    answer?: -2 | -1 | 0 | 1 | 2;
    answerLog?: Record<number, number>;
}

export interface RankQuestionBlock extends QnA_Block {
    qType: QuestionType.RANK;
    question: string; // 'qText' is used to check if a question is a single-sided question
    options: string[]; // 4-6 options to be ranked
    answer?: string; // takes the form #-#-# where # is the index of the option
    answerLog?: Record<number, string>;
    weightMod?: [number, number, number, number, number]; // 5-trait weight modifiers
    weights: Record<string, [number, number, number, number, number]>; // answer -> [weight, weight, weight, weight, weight]
}

/**
 * Value range: -1 to 1;
 * If the value is negative, it favors the left letter;
 * If the value is positive, it favors the right letter;
 * If 0 ... not decided
 */
export interface OEJTresult {
    IE: number;
    SN: number;
    FT: number;
    JP: number;
    AT: number;
}

export interface TestObject {
    testsetID: string; // The static ID for the testset, so that we can retrieve the testset from the server
    partOne: TwoSideQuestionBlock[];
    partTwo: SimpleQuestionBlock[];
    partThree: SimpleQuestionBlock[];
}